var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transactions',{attrs:{"transaction-class":_vm.transactionClass,"verbose-name":"Avoir","verbose-name-plural":"Avoirs","ressource":"credits","add":false,"colors":_vm.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }